export enum ClientDeployment{
  DEFAULT = "DEFAULT",
  HSTP = "HSTP"
}
